import Box from "@mui/material/Box/Box";
import styled from "@mui/material/styles/styled";

export const StyledBox = styled(Box)(() => ({
  borderBottom: 1,
  borderColor: "divider",
}));
